import { notification } from 'antd';
import { ReactNode } from 'react';
import { ArgsProps, ConfigProps } from 'antd/lib/notification';
import './notification.scss';
import { SetOptional } from '@bringg/types';

const defaultOptions = {
	placement: 'bottomRight',
	duration: 2
} as ConfigProps;

class Notification {
	setOptions = (options: ConfigProps): void => {
		notification.config(options);
	};

	// Don't delete class name ! for automation use
	success = (
		message?: ReactNode,
		description?: ReactNode,
		options?: SetOptional<ArgsProps, 'message' | 'description'>
	): void => {
		return notification.success({ className: 'success-notify', ...options, message, description });
	};

	error = (
		message?: ReactNode,
		description?: ReactNode,
		options?: SetOptional<ArgsProps, 'message' | 'description'>
	): void => {
		return notification.error({ className: 'error-notify', ...options, message, description });
	};

	info = (
		message?: ReactNode,
		description?: ReactNode,
		options?: SetOptional<ArgsProps, 'message' | 'description'>
	): void => {
		return notification.info({ className: 'info-notify', ...options, message, description });
	};

	warn = (
		message?: ReactNode,
		description?: ReactNode,
		options?: SetOptional<ArgsProps, 'message' | 'description'>
	): void => {
		return notification.warn({ className: 'warn-notify', ...options, message, description });
	};

	close = (key: string): void => {
		return notification.close(key);
	};

	// This should be used only in tests for cleanup
	destroy = (): void => {
		// This should be used only in tests
		if (process.env.NODE_ENV === 'test') {
			notification.destroy();
		}
	};
}

const bringgNotification = new Notification();
bringgNotification.setOptions(defaultOptions);

export const useNotification = notification.useNotification;
export default bringgNotification;
